/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Assignment_Email_Dont_Ask_AgainInputs */



/**
* | output |
* | --- |
* | "Don't ask me again" |
*
* @param {Explorer_Assignment_Email_Dont_Ask_AgainInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_assignment_email_dont_ask_again = /** @type {((inputs?: Explorer_Assignment_Email_Dont_Ask_AgainInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Assignment_Email_Dont_Ask_AgainInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ne plus demander")
	if (locale === "de") return /** @type {LocalizedString} */ ("Nicht erneut fragen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Non chiedere di nuovo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Больше не спрашивать")
	if (locale === "es") return /** @type {LocalizedString} */ ("No volver a preguntar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("不再询问")
	if (locale === "ja") return /** @type {LocalizedString} */ ("次回から確認しない")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फिर न पूछें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Não voltar a perguntar")
	return /** @type {LocalizedString} */ ("Don't ask me again")
});